import { Component, OnInit, ViewChild, Input, inject } from '@angular/core';
import { HomeFilter, HomeFilterLevel, HomeBanner } from 'src/app/models/client-configuration';
import { TopicService } from 'src/app/services/topic.service';
import { ConfigService } from 'src/app/services/config.service';
import { ThemeService } from 'src/app/services/theme.service';
import { ApiService } from 'src/app/services/api.service';
import { MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { LocaleService } from 'src/app/services/locale.service';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'app-topic-slider',
  templateUrl: './topic-slider.component.html',
  styleUrls: ['./topic-slider.component.scss'],
})
export class TopicSliderComponent implements OnInit {
  private readonly configService = inject(ConfigService);

  @ViewChild(MatMenuTrigger, { static: false })
  menuRef: MatMenuTrigger;

  @Input()
  topics: HomeFilter;

  subtopics: HomeFilterLevel[];

  readonly swiperConfiguration: SwiperOptions = {
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    breakpoints: {
      0: {
        slidesOffsetAfter: 8,
        slidesOffsetBefore: 8,
      },
    },
    navigation: {
      enabled: !this.configService.notDesktopDevice(),
    },
  };

  homeBanner: HomeBanner;
  bannerImageUrl: string;
  textDirection: string;

  constructor(
    configService: ConfigService,
    themeService: ThemeService,
    private apiService: ApiService,
    private topicService: TopicService,
    private localeService: LocaleService,
  ) {
    this.homeBanner = configService.get().homeBanner;
    this.bannerImageUrl = themeService.baseUrl + '/' + configService.get().homeBanner.imageUrl;
  }

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  open(topic: HomeFilterLevel) {
    this.topicService.goToResults(topic);
  }

  openBannerUrl() {
    const url = this.homeBanner.targetUrl;

    if (url) {
      if (url.endsWith('type=OTK')) {
        const wnd = window.open();
        this.apiService.getExternalLoginUrl(undefined, 'OTK').subscribe((_url) => (wnd.location.href = _url));
      } else {
        window.open(url, '_blank', 'noopener');
      }
    }
  }

  showSubtopics(topic: HomeFilterLevel) {
    this.subtopics = topic.nextLevel;
  }
}
